module.exports = __webpack_public_path__ + "own-product-available.svg?b659c553d457cc882260ecf2b39f782c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/own-product-available.svg
// module id = 304
// module chunks = 2